export default {
	api : {
		point : ''
	}
}